import React, { createContext, useContext, useState, ReactNode } from "react";

// 1. État pur du diagramme
type DiagramSettings = {
  gridVisible: boolean;
  gridSize: number;
  backgroundColorEnabled: boolean;
  backgroundColor: string;
  shadowEnabled: boolean;
  showGuides: boolean;
  connectionArrows: boolean;
  connectionPoints: boolean;
  paperSize: string;
  orientation: "portrait" | "landscape";
};

// 2. Contexte avec actions
type DiagramSettingsContextType = DiagramSettings & {
  setSettings: (updates: Partial<DiagramSettings>) => void;
};

// 3. Valeurs par défaut
const defaultSettings: DiagramSettings = {
  gridVisible: true,
  gridSize: 20,
  backgroundColorEnabled: false,
  backgroundColor: "#ffffff",
  shadowEnabled: false,
  showGuides: true,
  connectionArrows: true,
  connectionPoints: true,
  paperSize: "A1",
  orientation: "portrait",
};

// 4. Création du contexte (vide par défaut mais typé)
const DiagramSettingsContext = createContext<DiagramSettingsContextType | undefined>(undefined);

// 5. Hook pour utiliser le contexte
export const useDiagramSettings = () => {
  const context = useContext(DiagramSettingsContext);
  if (!context) throw new Error("useDiagramSettings must be used within DiagramSettingsProvider");
  return context;
};

// 6. Provider global
export const DiagramSettingsProvider = ({ children }: { children: ReactNode }) => {
  const [settings, setSettingsState] = useState<DiagramSettings>(defaultSettings);

  const setSettings = (updates: Partial<DiagramSettings>) => {
    setSettingsState((prev) => ({ ...prev, ...updates }));
  };

  return (
    <DiagramSettingsContext.Provider value={{ ...settings, setSettings }}>
      {children}
    </DiagramSettingsContext.Provider>
  );
};
